package com.castly.admin.ui.audiobooks

import androidx.compose.runtime.*
import com.castly.admin.api.ApiClient
import com.castly.admin.ui.theme.AppTheme
import com.castly.admin.ui.theme.BorderRadius
import com.castly.admin.ui.theme.Spacing
import com.castly.admin.ui.theme.Typography
import com.castly.admin.ui.theme.themeTransition
import com.castly.shared.dto.OnixExportRequest
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

@Composable
fun OnixExportButton(
    apiClient: ApiClient,
    searchQuery: String = ""
) {
    val colors = AppTheme.colors
    var isExporting by remember { mutableStateOf(false) }
    var errorMessage by remember { mutableStateOf<String?>(null) }
    val scope = rememberCoroutineScope()

    // Auto-dismiss error
    LaunchedEffect(errorMessage) {
        if (errorMessage != null) {
            kotlinx.coroutines.delay(5000)
            errorMessage = null
        }
    }

    Div({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            gap(Spacing.sm)
        }
    }) {
        Button({
            if (isExporting) disabled()
            onClick {
                isExporting = true
                errorMessage = null
                scope.launch {
                    try {
                        val request = OnixExportRequest(
                            search = searchQuery.takeIf { it.isNotBlank() }
                        )
                        val xmlContent = apiClient.exportOnix(request)

                        // Trigger browser download
                        val blob = Blob(arrayOf(xmlContent), BlobPropertyBag(type = "application/xml"))
                        val url = URL.createObjectURL(blob)
                        val anchor = document.createElement("a") as HTMLAnchorElement
                        anchor.href = url
                        anchor.download = "audiobooks-export.xml"
                        anchor.click()
                        URL.revokeObjectURL(url)
                    } catch (e: Exception) {
                        errorMessage = e.message ?: "Export failed"
                    } finally {
                        isExporting = false
                    }
                }
            }
            style {
                padding(6.px, Spacing.md)
                fontSize(13.px)
                fontWeight("500")
                color(Color(colors.text))
                backgroundColor(Color(colors.surface))
                border(1.px, LineStyle.Solid, Color(colors.border))
                borderRadius(BorderRadius.md)
                cursor(if (isExporting) "not-allowed" else "pointer")
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                gap(6.px)
                property("transition", "all 0.2s")
            }
        }) {
            com.castly.admin.ui.icons.IconDownload(size = 14)
            Text(if (isExporting) "Exporting..." else "Export ONIX")
        }

        errorMessage?.let { error ->
            Span({
                style {
                    fontSize(12.px)
                    color(Color(colors.danger))
                }
            }) { Text(error) }
        }
    }
}
